import './App.css';
import { Routes, Route } from 'react-router-dom'

import Navbar from './components/Navbar'
import Home from './pages/Home'
import Cart from './pages/Cart'

function App() {
  return (
    <div>
      <div className='bg-slate-900 '>
        <Navbar />
      </div>
      
      <Routes>
        <Route path='/' element= {<Home/>}/>
        <Route path='/Shopping-Cart' element= {<Home/>}/>
        <Route path='/cart' element= {<Cart/>}/>
        <Route path='/Shopping-Cart/cart' element= {<Cart/>}/>
        <Route path='/*' element= {<Home/>}/>
      </Routes>

    </div>
  );
}

export default App;
